export default __webpack_public_path__ + "static/media/TCInfo.6af60cc0.svg";